__turbopack_context__.v({
  "asideCol": "HostingMigrationSection-module__olN5Ca__asideCol",
  "asideFooter": "HostingMigrationSection-module__olN5Ca__asideFooter",
  "asideGrid": "HostingMigrationSection-module__olN5Ca__asideGrid",
  "asideIcon": "HostingMigrationSection-module__olN5Ca__asideIcon",
  "asideText": "HostingMigrationSection-module__olN5Ca__asideText",
  "asideTile": "HostingMigrationSection-module__olN5Ca__asideTile",
  "asideTitle": "HostingMigrationSection-module__olN5Ca__asideTitle",
  "badge": "HostingMigrationSection-module__olN5Ca__badge",
  "cta": "HostingMigrationSection-module__olN5Ca__cta",
  "ctaBtn": "HostingMigrationSection-module__olN5Ca__ctaBtn",
  "ctaSub": "HostingMigrationSection-module__olN5Ca__ctaSub",
  "ctaTitle": "HostingMigrationSection-module__olN5Ca__ctaTitle",
  "eyebrow": "HostingMigrationSection-module__olN5Ca__eyebrow",
  "metric": "HostingMigrationSection-module__olN5Ca__metric",
  "metrics": "HostingMigrationSection-module__olN5Ca__metrics",
  "section": "HostingMigrationSection-module__olN5Ca__section",
  "spin": "HostingMigrationSection-module__olN5Ca__spin",
  "step": "HostingMigrationSection-module__olN5Ca__step",
  "stepBadges": "HostingMigrationSection-module__olN5Ca__stepBadges",
  "stepBody": "HostingMigrationSection-module__olN5Ca__stepBody",
  "stepNum": "HostingMigrationSection-module__olN5Ca__stepNum",
  "stepText": "HostingMigrationSection-module__olN5Ca__stepText",
  "stepTitle": "HostingMigrationSection-module__olN5Ca__stepTitle",
  "sub": "HostingMigrationSection-module__olN5Ca__sub",
  "timeline": "HostingMigrationSection-module__olN5Ca__timeline",
  "title": "HostingMigrationSection-module__olN5Ca__title",
});
